import cn from "classnames";
import { accountsReceivableReportSources } from "helpers/enums";
import React, { useState } from "react";

const debtModes = [
    { label: "Дебиторская задолженность", value: false },
    { label: "Кредиторская задолженность", value: true },
];

const AccountsReceivableFilters = ({ values, setFilter, getItem, forceUpdateReport }) => {
    const [blocked, setBlocked] = useState(false);
    const changeFilter = (name, value) => {
        if (blocked || values[name] === value) {
            return;
        }
        setBlocked(true);
        setFilter({ name, value });
        setTimeout(() => {
            getItem().finally(() => {
                setBlocked(false);
                forceUpdateReport();
            });
        }, 0);
    };

    return (
        <div className="d-flex flex-wrap justify-content-end align-items-center">
            <div className="btn-group report__filters--mr" role="group" aria-label="Режим взаиморасчётов">
                {debtModes.map((mode) => (
                    <button
                        key={`${mode.value}`}
                        type="button"
                        className={cn("btn btn-xs", {
                            "btn-dark": values.isAccountsPayable === mode.value,
                            "btn-secondary": values.isAccountsPayable !== mode.value,
                        })}
                        disabled={blocked}
                        onClick={() => changeFilter("isAccountsPayable", mode.value)}
                    >
                        {mode.label}
                    </button>
                ))}
            </div>
            {!values.isAccountsPayable && (
                <div className="report__filters--mr">
                    <select
                        aria-label="Источник данных"
                        className="form-control form-control-xs w-auto"
                        value={values.source || accountsReceivableReportSources[0].value}
                        disabled={blocked}
                        onChange={(event) => changeFilter("source", event.target.value)}
                    >
                        {accountsReceivableReportSources.map((source) => (
                            <option key={source.value} value={source.value}>
                                {source.label}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default AccountsReceivableFilters;
